<div class="page">
  <app-page-header itemName="{{ company.get('name') }}" page-title="companies.detail.pageTitle"></app-page-header>
  <div class="page-content">

    <div class="alert alert-danger text-center mb-4" *ngIf="companyData && !companyData.active">
      {{ 'companies.detail.suspended_company_alert' | translate }}
    </div>

    <!-- DETAIL CARD -->
    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <div class="mt-2 mb-4 d-flex align-items-center">
            <button class="add-icon-button mr-2" color="primary" (click)="onToggleSendEmail('enable')" mat-flat-button
              matTooltip="{{ 'companies.detail.enableSendEmail' | translate }}" matTooltipPosition="above"
              *ngIf="!loggedUserMaster && disableSendEmail">
              <mat-icon fontSet="fal" fontIcon="fa-check"></mat-icon> {{ 'companies.detail.enableSendEmail' | translate }}
            </button>

            <button class="add-icon-button ml-auto" color="primary" mat-flat-button
              [matMenuTriggerFor]="companyActionsMenu">
              {{ 'common.cta.actions' | translate }}
              <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
            </button>
            <mat-menu #companyActionsMenu="matMenu" [hasBackdrop]="true">
              <button mat-menu-item (click)="onToggleSendEmail('disable')"
                *ngIf="!loggedUserMaster && !disableSendEmail && company.get('pec') !== ''">
                <mat-icon fontSet="fal" fontIcon="fa-ban"></mat-icon>
                {{ 'companies.detail.disableSendEmail' | translate }}
              </button>
              <button mat-menu-item (click)="onExportTechnicalFile()" *ngIf="!loggedUserMaster">
                <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                {{ 'companies.detail.technicalFile' | translate }}
              </button>
              <button mat-menu-item (click)="onToggleShowMasterCode()">
                <mat-icon fontSet="fal" [fontIcon]="showMasterCode ? 'fa-eye-slash' : 'fa-eye'"></mat-icon>
                {{ (showMasterCode ? 'companies.detail.hideMasterCode' : 'companies.detail.showMasterCode') | translate }}
              </button>
              <button mat-menu-item (click)="onShowCompanyId()" *ngIf="loggedUserAdminOrOperator">
                <mat-icon fontSet="fal" fontIcon="fa-id-badge"></mat-icon>
                {{ 'companies.detail.showCompanyId' | translate }}
              </button>
            </mat-menu>
          </div>

          <app-creator-updator-box [data]="company"></app-creator-updator-box>
          <!-- -->
          <div class="container-fluid box-contract" *ngIf="disclaimer">
            <div class="row">
              <div class="col-12 col-md-6">
                <mat-list dense class="left-aligned-mat-list">
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApprovedAt' | translate }}:</strong>
                    {{ disclaimerAt | date:'dd LLL yyyy HH:mm' }}
                  </mat-list-item>
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApprovedBy' | translate }}:</strong>
                    {{ disclaimerUser }}
                  </mat-list-item>
                </mat-list>
              </div> <!-- /.col -->
              <div class="col-12 col-md-6">
                <mat-list dense class="left-aligned-mat-list">
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApproved' | translate }}:</strong>
                    <button class="mr-2" mat-stroked-button color="primary" (click)="onGetContract()">
                      <mat-icon class="mr-1" fontSet="fal" fontIcon="fa-download"></mat-icon>
                      {{ 'companies.detail.downloadContract' | translate }}
                    </button>
                  </mat-list-item>
                </mat-list>
              </div> <!-- /.col -->
            </div> <!-- /.row -->
          </div> <!-- /.container -->
          <!-- -->
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(1)">
              <formly-form [form]="form" [fields]="anagraphicFields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- CONTRACT CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="model && model.types && model.types.includes('manager') && loggedUserPermissions.includes('canCreateSubscriptions')">
      <mat-card-title>{{ 'companies.fields.subscription.titleSection' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <div class="alert alert-primary text-center mb-4">
              <mat-slide-toggle class="toggle-activation-btn" color="accent" [checked]="enableEdit"
                (change)="onToggleSelected($event)" matTooltipPosition="right"
                matTooltip="{{ 'companies.detail.contractTab.toggleTooltip' | translate }}">
                <mat-label>{{ 'companies.detail.contractTab.toggleLabel' | translate }}</mat-label>
              </mat-slide-toggle>
            </div>
            <form [formGroup]="formSC" (ngSubmit)="onFormSubmit(2)">
              <formly-form [form]="formSC" [fields]="contractFields" [model]="modelSC"
                [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate mt-4">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- BALANCES CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="company && loggedUser && loggedUserPermissions.includes('canReadBalancesList')">
      <mat-card-title>{{ 'companies.detail.balancesTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="balancesCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #balancesInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="balancesInput.value"></mat-icon>
                  </mat-form-field>
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onViewBalancesNotes()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-sticky-note"></mat-icon>
                    {{ 'platformNotes.dialog.propertyNotes.title' | translate }}
                  </button>
                  <button mat-button (click)="onExportBalances()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportBalances')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="is-loading" *ngIf="balancesDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="balancesDataSource" matSort #balancesSort="matSort" matSortActive="number"
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'balances.fields.number' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="numberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(numberFilter)"
                        class="reset-input-icon" *ngIf="numberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'balances.fields.property' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../../properties/{{ element.property?._id}}/home">
                      {{ element.property?.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                    <!-- <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field> -->
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'balances.fields.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip *ngIf="element.status.includes('open');" selected class="mat-chip-sm chip-green">
                        {{ 'balances.status.open' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.status.includes('pending');" selected class="mat-chip-sm chip-yellow">
                        {{ 'balances.status.pending' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.status.includes('closed');" selected class="mat-chip-sm chip-red">
                        {{ 'balances.status.closed' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-select [formControl]="statusFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="open">{{ 'balances.status.open' | translate }}</mat-option>
                        <mat-option value="pending">{{ 'balances.status.pending' | translate }}</mat-option>
                        <mat-option value="close">{{ 'balances.status.closed' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(statusFilter)"
                        class="reset-input-icon" *ngIf="statusFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="discount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.discount' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.discount }} <mat-label matSuffix>%</mat-label>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="number" matInput [formControl]="discountFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(discountFilter)"
                        class="reset-input-icon" *ngIf="discountFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.total' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.total }} <mat-label matSuffix>€</mat-label>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="number" matInput [formControl]="totalFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(totalFilter)"
                        class="reset-input-icon" *ngIf="totalFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.words.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a [routerLink]="'../../../balances/detail/' + element._id" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="balancesDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: balancesDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="balancesDisplayedColumns"></tr>
              </table>
              <mat-paginator #balancesPaginator [length]="balancesDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SUB USERS CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="company && loggedUser && loggedUserPermissions.includes('canReadSubUsersList')">
      <mat-card-title>{{ 'companies.detail.subUsersTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="subUsersCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <button mat-raised-button color="primary" (click)="onAddSubUser()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateCompanies')"
            matTooltip="{{ 'companies.detail.subUsersTab.add.tooltip' | translate }}">
            <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>
          <div class="alert alert-warning my-3" role="alert"
            *ngIf="!company.subUsers || company.subUsers.length === 0 && (subUsersDataSource.totalCount$ | async) === 0">
            {{ 'common.words.display_no_data' | translate }}
          </div>
          <div class="is-loading" *ngIf="subUsersDataSource.loading$ | async">
            <mat-spinner diameter="50"></mat-spinner>
          </div>

          <div class="table-responsive" [ngClass]="{'d-none': ((subUsersDataSource.totalCount$ | async) === 0)}">
            <table mat-table [dataSource]="subUsersDataSource" matSort #subUsersSort="matSort" matSortActive="firstName"
              matSortDirection="asc" matSortDisableClear class="mat-elevation-z0 w-100">
              <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ i + 1 }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                  {{ 'companies.fields.subUser.role' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <mat-chip-list class="d-block py-2 px-1">
                    <mat-chip *ngIf="element.role === 'master'" color="accent" selected class="mat-chip-sm">
                      {{ 'roles.types.master' | translate }}
                    </mat-chip>
                    <mat-chip *ngIf="element.role === 'collaborator'" color="none" selected class="mat-chip-sm">
                      {{ 'roles.types.collaborator' | translate }}
                    </mat-chip>
                    <mat-chip *ngIf="element.role === 'temporary'" color="none" selected class="mat-chip-sm">
                      {{ 'roles.types.temporary' | translate }}
                    </mat-chip>
                  </mat-chip-list>
                </td>
              </ng-container>
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                  {{ 'companies.fields.subUser.firstName' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.firstName }} </td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                  {{ 'companies.fields.subUser.lastName' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.lastName }} </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'companies.fields.subUser.email' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.email }} </td>
              </ng-container>
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'common.words.createdAt' | translate }}
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.createdAt | dateTimeFormat }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.cta.actions' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="text-right">
                  <a [routerLink]="'../../../users/detail/' + element.userId + '/' + company._id" mat-raised-button
                    color="primary" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                    {{ 'common.cta.open' | translate }}
                    <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                  </a>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="subUsersDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: subUsersDisplayedColumns;"></tr>
            </table>
            <mat-paginator #subUsersPaginator [length]="subUsersDataSource.totalCount$ | async" [pageSize]="10"
              [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
          </div> <!-- /.table-responsive -->

        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SUB PROPERTIES CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="company && loggedUser && loggedUserPermissions.includes('canReadPropertiesList')">
      <!-- *ngIf="company && loggedUser && loggedUserPermissions.includes('canReadSubPropertiesList')"> -->
      <mat-card-title>{{ 'companies.detail.subPropertiesTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="subPropertiesCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #subPropertiesInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetSubPropertiesInput()"
                      class="reset-input-icon" *ngIf="subPropertiesInput.value"></mat-icon>
                  </mat-form-field>
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSubProperties()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetSubPropertiesFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="alert alert-warning my-3" role="alert"
              *ngIf="!company.subProperties || company.subProperties.length === 0 && (subPropertiesDataSource.totalCount$ | async) === 0">
              {{ 'common.words.display_no_data' | translate }}
            </div>
            <div class="is-loading" *ngIf="subPropertiesDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <!-- <div class="table-responsive" [ngClass]="{'d-none': ((subPropertiesDataSource.totalCount$ | async) === 0)}"> -->
              <table mat-table [dataSource]="subPropertiesDataSource" matSort #subPropertiesSort="matSort"
                matSortActive="name" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0 w-100">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="hasNotes">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button (click)="onOpenNotes(element.propertyId)" *ngIf="element.hasNotes">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-exclamation" color="primary"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a class="ml-2" routerLink="../../../properties/{{element.propertyId}}/home">
                      {{ element.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(nameFilter)" class="reset-input-icon"
                        *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="masterCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.masterCode' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.masterCode || ('common.words.dashes' | translate) }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="masterCodeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(masterCodeFilter)" class="reset-input-icon"
                        *ngIf="masterCodeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    title="{{ 'properties.fields.address' | translate }}" class="col-fixed-md">
                    {{ 'common.words.address' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.address?.route }} {{ element.address?.streetNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="addressFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(addressFilter)" class="reset-input-icon"
                        *ngIf="addressFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="addressCity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    title="{{ 'properties.fields.addressCity' | translate }}">
                    {{ 'common.words.city' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.address?.city }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="addressCityFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(addressCityFilter)" class="reset-input-icon"
                        *ngIf="addressCityFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="admin">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'properties.fields.admin' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../companies/detail/{{ element.admin?._id}}">
                      {{ element.admin?.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="adminFilter" [matAutocomplete]="adminAuto">
                      <mat-autocomplete autoActiveFirstOption #adminAuto="matAutocomplete"
                        [displayWith]="displayAdminOrOwnerFn.bind(this)"
                        (onSelectionChange)="onAdminFilterSelected($event)">
                        <mat-option *ngIf="adminIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!adminIsLoading">
                          <mat-option *ngFor="let admin of availableAdmins" [value]="admin"
                            (onSelectionChange)="onAdminFilterSelected($event)">
                            <small>{{ admin.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(adminFilter)" class="reset-input-icon"
                        *ngIf="adminFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                    {{ 'properties.fields.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.status }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="propertiesStatusFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="sag">{{ 'properties.statusTypes.sag' | translate }}</mat-option>
                        <mat-option value="mappConf">{{ 'properties.statusTypes.mappConf' | translate }}</mat-option>
                        <mat-option value="mappTermin">{{ 'properties.statusTypes.mappTermin' | translate
                          }}</mat-option>
                        <mat-option value="inserimConf">{{ 'properties.statusTypes.inserimConf' | translate
                          }}</mat-option>
                        <mat-option value="inserimConfParz">{{ 'properties.statusTypes.inserimConfParz' | translate
                          }}</mat-option>
                        <mat-option value="inserimTermin">{{ 'properties.statusTypes.inserimTermin' | translate
                          }}</mat-option>
                        <mat-option value="inserimTerminParz">{{ 'properties.statusTypes.inserimTerminParz' | translate
                          }}</mat-option>
                        <mat-option value="mappCompl">{{ 'properties.statusTypes.mappCompl' | translate }}</mat-option>
                        <mat-option value="mappParz">{{ 'properties.statusTypes.mappParz' | translate }}</mat-option>
                        <mat-option value="ceased">{{ 'properties.statusTypes.ceased' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(propertiesStatusFilter)" class="reset-input-icon ml-n3"
                        *ngIf="propertiesStatusFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="subscriptionEndDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.subscriptionEndDateColumn' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.subscriptionEndDate !== '----'">
                      {{ element.subscriptionEndDate | dateFormat }}
                    </span>
                    <span *ngIf="element.subscriptionEndDate === '----'">
                      {{ element.subscriptionEndDate }}
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="subscriptionEndDateFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(subscriptionEndDateFilter)" class="reset-input-icon"
                        *ngIf="subscriptionEndDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="totalDocsInserted">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                    {{ 'properties.fields.totalDocs' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.totalDocsInserted ? element.totalDocsInserted : 0 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput type="number" [formControl]="totalDocsInsertedFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSubPropertiesFilter(totalDocsInsertedFilter)" class="reset-input-icon"
                        *ngIf="totalDocsInsertedFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="structureOpen">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'properties.fields.structureOpen' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip
                        *ngIf="element.structureOpen === 'true' && element.subscriptionKey !== 'FREE' && element.subscriptionKey !== 'FREEBASIC'"
                        selected class="mat-chip-sm chip-green">
                        {{ 'common.words.openFemale' | translate }}
                      </mat-chip>
                      <mat-basic-chip
                        *ngIf="element.structureOpen === 'true' && (element.subscriptionKey === 'FREE' || element.subscriptionKey === 'FREEBASIC')"
                        selected>
                        {{ 'properties.list.structureFree' | translate }}
                      </mat-basic-chip>
                      <mat-chip *ngIf="element.structureOpen === 'false'" selected class="mat-chip-sm chip-red">
                        {{ 'common.words.closedFemale' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  </td>
                </ng-container>
                <!-- <ng-container matColumnDef="roles">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'companies.detail.subPropertiesTab.fields.roles' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <mat-chip-list class="d-block" *ngFor="let role of element.roles">
                    <mat-chip *ngIf="role === 'owner'" color="primary" selected class="mat-chip-sm">
                      {{ 'properties.fields.' + role | translate }}
                    </mat-chip>
                    <mat-chip *ngIf="role === 'admin'" color="warn" selected class="mat-chip-sm">
                      {{ 'properties.fields.' + role | translate }}
                    </mat-chip>
                  </mat-chip-list>
                </td>
              </ng-container>

              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                  {{ 'common.words.createdAt' | translate }}
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.createdAt | dateTimeFormat }}</td>
              </ng-container> -->

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'common.cta.actions' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <a mat-menu-item routerLink="../../../properties/{{ element.propertyId }}/home">{{
                        'properties.list.goToData' | translate }}</a>
                      <a mat-menu-item routerLink="../../../properties/{{ element.propertyId }}/mapping"
                        *ngIf="loggedUserPermissions.includes('canReadCondoStructuresList') && element.subscriptionKey !=='FREE' && element.subscriptionKey !== 'FREEBASIC' && element.subscriptionKey !=='noSubscription'">
                        {{ 'properties.list.goToMapping' | translate }}</a>
                      <a mat-menu-item routerLink="../../../properties/{{ element.propertyId }}/documents"
                        *ngIf="element.subscriptionKey !=='noSubscription'">{{ 'properties.list.goToDocuments' |
                        translate }}</a>
                      <a mat-menu-item routerLink="../../../properties/{{ element.propertyId }}/search"
                        *ngIf="element.subscriptionKey !=='noSubscription'">{{ 'properties.list.searchDocuments' |
                        translate }}</a>

                      <button mat-menu-item
                        *ngIf="loggedUserPermissions.includes('canExportProperties') && element.subscriptionKey !=='noSubscription'"
                        (click)="onExport('insertedDocs2025', element.propertyId)">{{
                        'properties.list.exportExpiredDocuments' | translate }}</button>
                      <button mat-menu-item
                        *ngIf="loggedUserPermissions.includes('canExportProperties') && element.subscriptionKey !=='noSubscription' && element.subscriptionKey !=='FREE' && element.subscriptionKey !== 'FREEBASIC'"
                        (click)="onExport('missingDocs', element.propertyId)">{{
                        'properties.list.exportMissingDocuments' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="subPropertiesDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: subPropertiesDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="subPropertiesDisplayedColumns"></tr>
              </table>
              <mat-paginator #subPropertiesPaginator [length]="subPropertiesDataSource.totalCount$ | async"
                [pageSize]="10" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SUPPLIERS -->
    <mat-card class="custom-card mt-4" [hidden]="hiddenCardSuppliers">
      <mat-card-title>
        {{ 'suppliers.list.listTab.title' | translate }}
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.suppliers" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="suppliersCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="row mb-2">
            <div class="col-6">
            </div>
            <div class="col-6 text-right">
              <div [hidden]="!nfcAccess">
                <button mat-flat-button color="primary" (click)="onInviteSuppliers()">
                  <mat-icon fontSet="far" fontIcon="fa-paper-plane"></mat-icon>
                  {{ 'suppliers.assessment.btnInviteSuppliers' | translate }}
                </button>
              </div>
            </div>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSuppliers()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportSuppliers')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersSuppliers()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="suppliersDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="suppliersDataSource" matSort #suppliersSort="matSort"
                matSortActive="companyName" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <mat-checkbox [checked]="element.checked" (change)="onSubsSelected(element, $event.checked)"
                      class="checkbox-insert">
                    </mat-checkbox>
                    <!-- <a (click)="onOpenDialog(element)" mat-raised-button color="primary"
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        {{ 'common.cta.open' | translate }}
                        <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                      </a> -->
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">{{ 'suppliers.fields.name'
                    | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <a class="ml-2" [routerLink]="'../../../suppliers/detailv2/' + element._id"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ element.companyName }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="companyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(companyNameFilter)" class="reset-input-icon"
                        *ngIf="companyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="registration">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xs text-center">
                    <div>
                      <table>
                        <td>{{ 'suppliers.fields.registration' | translate }}</td>
                        <td>
                          <button mat-icon-button aria-label="Info" (mouseover)="onInfoRegistrationPopUp()">
                            <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                          </button>
                        </td>
                      </table>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div *ngIf="element.status === 'ceased' && !element.notRegistered && element.registration && element.registration.file">
                      <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.registration.file.path }}"
                        target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: #000000;" *ngIf="element.registration.date">{{ element.registration.date |
                          dateDocumentFormat }}</span>
                      </a>
                    </div>
                    <div *ngIf="element.status === 'ceased' && !element.notRegistered && element.registration && !element.registration.file">
                      <span style="color: #000000;" *ngIf="element.registration.date">{{ element.registration.date |
                        dateDocumentFormat }}</span>
                    </div>

                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.registration && element.registration.file && element.registration.status === 'valid'">
                      <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.registration.file.path }}"
                        target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: #28a745;" *ngIf="element.registration.date">{{ element.registration.date |
                          dateDocumentFormat }}</span>
                        <span style="color: #28a745;" *ngIf="!element.registration.date">{{
                          'suppliers.fields.supplierDocuments.valid' | translate }}</span>
                      </a>
                    </div>
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.registration && !element.registration.file && element.registration.status === 'valid'">
                      <span style="color: #28a745;" *ngIf="element.registration.date">{{ element.registration.date |
                        dateDocumentFormat }}</span>
                      <span style="color: #28a745;" *ngIf="!element.registration.date">{{
                        'suppliers.fields.supplierDocuments.valid' | translate }}</span>
                    </div>
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.registration && element.registration.file && element.registration.status === 'notValid'">
                      <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.registration.file.path }}"
                        target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: #dc3545;" *ngIf="element.registration.date">{{ element.registration.date |
                          dateDocumentFormat }}</span>
                        <span style="color: #dc3545;" *ngIf="!element.registration.date">{{
                          'suppliers.fields.supplierDocuments.notValid' | translate }}</span>
                      </a>
                    </div>
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.registration && !element.registration.file && element.registration.status === 'notValid'">
                      <span style="color: #dc3545;" *ngIf="element.registration.date">{{ element.registration.date |
                        dateDocumentFormat }}</span>
                      <span style="color: #dc3545;" *ngIf="!element.registration.date">{{
                        'suppliers.fields.supplierDocuments.notValid' | translate }}</span>
                    </div>
                    <div *ngIf="element.status !== 'ceased' && element.notRegistered">
                      <span style="color: #000000;">{{ 'suppliers.fields.supplierDocuments.notExpected' | translate
                        }}</span>
                    </div>

                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="registrationFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="valid">
                          <small>{{ 'suppliers.fields.supplierDocuments.valid' | translate }}</small>
                        </mat-option>
                        <mat-option value="notValid">
                          <small>{{ 'suppliers.fields.supplierDocuments.notValid' | translate }}</small>
                        </mat-option>
                        <mat-option value="notRegistered">
                          <small>{{ 'suppliers.fields.supplierDocuments.notExpected' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(registrationFilter)" class="reset-input-icon"
                        *ngIf="registrationFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="durc">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xs text-center">
                    {{ 'suppliers.fields.durc' | translate }}
                    <button mat-icon-button aria-label="Info" (mouseover)="onInfoDurcPopUp()">
                      <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div *ngIf="element.exemptionDurc">
                      <div *ngIf="element.exemptionDurc && element.durc && element.durc.file">
                        <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.durc.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: black;">{{ 'suppliers.fields.supplierDocuments.exemption' | translate
                            }}</span>
                        </a>
                      </div>
                      <div *ngIf="element.exemptionDurc && (!element.durc || !element.durc.file)">
                        {{ 'suppliers.fields.supplierDocuments.exemption' | translate }}
                      </div>
                    </div>
                    <div
                      *ngIf="!element.exemptionDurc && element.status !== 'ceased' && element.status !== 'suspended' && !element.notRegistered && element.durc && element.durc.status === 'valid'">
                      <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.durc.file.path }}"
                        target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: #28a745;" *ngIf="element.durc.expirationDate">{{
                          element.durc.expirationDate | dateDocumentFormat }}</span>
                        <span style="color: #28a745;" *ngIf="!element.durc.expirationDate">{{
                          'suppliers.fields.supplierDocuments.valid' | translate }}</span>
                      </a>
                    </div>
                    <div
                      *ngIf="!element.exemptionDurc && element.status !== 'ceased' && element.status !== 'suspended' && !element.notRegistered && element.durc && element.durc.file && (element.durc.status === 'notValid' || element.durc.status === 'expired')">
                      <a class="docLink" href="{{ configService.apiSuppliersHost }}{{ element.durc.file.path }}"
                        target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: #dc3545;" *ngIf="element.durc.expirationDate">{{
                          element.durc.expirationDate | dateDocumentFormat }}</span>
                        <span style="color: #dc3545;" *ngIf="!element.durc.expirationDate">{{
                          'suppliers.fields.supplierDocuments.notValid' | translate }}</span>
                      </a>
                    </div>
                    <!--
                      "NON PERVENUTO": the supplier declared it will not provide the DURC
                      (set-durc-not-received). No link and no expiration date are shown even
                      when an old file is still attached: those data would be stale.
                    -->
                    <div
                      *ngIf="!element.exemptionDurc && element.status !== 'ceased' && element.status !== 'suspended' && !element.notRegistered && element.durc && element.durc.status === 'notReceived'">
                      <span style="color: #dc3545;">{{ 'suppliers.fields.supplierDocuments.notReceivedDurc' | translate
                        }}</span>
                    </div>
                    <div
                      *ngIf="!element.exemptionDurc && element.status !== 'ceased' && element.status !== 'suspended' && (!element.notRegistered || element.notRegistered === '') && !(element.durc && element.durc.status === 'notReceived') && (!element.durc || !element.durc.file || (element.durc && element.durc.status === ''))">
                      <span style="color: #dc3545;">{{ 'suppliers.fields.supplierDocuments.missing' | translate
                        }}</span>
                    </div>
                    <div
                      *ngIf="!element.exemptionDurc && element.status === 'ceased' || element.status === 'suspended' || element.notRegistered">
                      {{ 'common.words.dashes' | translate }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="durcFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="valid">
                          <small>{{ 'suppliers.fields.supplierDocuments.valid' | translate }}</small>
                        </mat-option>
                        <mat-option value="notValid">
                          <small>{{ 'suppliers.fields.supplierDocuments.notValid' | translate }}</small>
                        </mat-option>
                        <mat-option value="exemption">
                          <small>{{ 'suppliers.fields.supplierDocuments.exemption' | translate }}</small>
                        </mat-option>
                        <mat-option value="expired">
                          <small>{{ 'suppliers.fields.supplierDocuments.expired' | translate }}</small>
                        </mat-option>
                        <mat-option value="missing">
                          <small>{{ 'suppliers.fields.supplierDocuments.missing' | translate }}</small>
                        </mat-option>
                        <mat-option value="notReceived">
                          <small>{{ 'suppliers.fields.supplierDocuments.notReceivedDurc' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetSuppliersFilter(durcFilter)"
                        class="reset-input-icon" *ngIf="durcFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="creditLicence">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-sm text-center">
                    <div>
                      <table>
                        <td>
                          <span style="text-wrap: nowrap;">{{ 'suppliers.fields.creditLicenceA' | translate
                            }}</span><br>
                          {{ 'suppliers.fields.creditLicenceB' | translate }}
                        </td>
                        <td>
                          <button mat-icon-button aria-label="Info" (mouseover)="onInfoCreditLicencePopUp()">
                            <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                          </button>
                        </td>
                      </table>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div *ngIf="element.notCreditLicence">
                      <a class="docLink"
                        href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}" target="_blank"
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        <span style="color: black;">{{ 'suppliers.fields.notCreditLicence' | translate }}</span>
                      </a>
                    </div>
                    <div *ngIf="!element.notCreditLicence">
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.status === 'valid' && element.creditLicence.type==='pac'">
                        <a class="docLink"
                          href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: #28a745;" *ngIf="element.creditLicence.date">{{
                            element.creditLicence.date | dateDocumentFormat }}</span>
                          <span style="color: #28a745;" *ngIf="!element.creditLicence.date">{{
                            'suppliers.fields.supplierDocuments.valid' | translate }}</span>
                        </a>
                      </div>
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.file && (element.creditLicence.status === 'notValid' || element.creditLicence.status === 'expired') && element.creditLicence.type==='pac'">
                        <a class="docLink"
                          href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: #dc3545;" *ngIf="element.creditLicence.status === 'expired'">{{
                            element.creditLicence.expirationDate | dateDocumentFormat }}</span>
                          <span style="color: #dc3545;" *ngIf="element.creditLicence.status === 'notValid'">{{
                            'suppliers.fields.supplierDocuments.notValid' | translate }}</span>
                        </a>
                      </div>
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.status === 'valid' && element.creditLicence.type==='soa'">
                        <a class="docLink"
                          href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: #28a745;">SOA</span>
                        </a>
                      </div>
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.file && (element.creditLicence.status === 'notValid' || element.creditLicence.status === 'expired') && element.creditLicence.type==='soa'">
                        <a class="docLink"
                          href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: #dc3545;">SOA</span>
                        </a>
                      </div>
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.file && element.creditLicence.type==='exemptionPac'">
                        <a class="docLink"
                          href="{{ configService.apiSuppliersHost }}{{ element.creditLicence.file.path }}"
                          target="_blank" matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          <span style="color: black">{{ 'suppliers.fields.notCreditLicence' | translate }}</span>
                        </a>
                      </div>
                      <!--
                        "NON PERVENUTA": the supplier declared it will not provide the PAC.
                        It takes precedence over the "waiting" placeholder below.
                      -->
                      <div
                        *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.status === 'notReceived'">
                        <span style="color: #dc3545;">{{ 'suppliers.fields.supplierDocuments.notReceived' | translate
                          }}</span>
                      </div>
                      <div
                        *ngIf="element.status === 'active' && !(element.creditLicence && element.creditLicence.status === 'notReceived') && (!element.creditLicence || !element.creditLicence.file || (element.creditLicence && element.creditLicence.status === ''))">
                        {{ 'suppliers.fields.supplierDocuments.waiting' | translate }}
                      </div>
                      <div
                        *ngIf="element.status !== 'active' && element.status !== 'ceased' && !element.notRegistered && !(element.creditLicence && element.creditLicence.status === 'notReceived') && (!element.creditLicence || !element.creditLicence.file || (element.creditLicence && element.creditLicence.status === ''))">
                        {{ 'suppliers.fields.supplierDocuments.waiting' | translate }}
                      </div>
                      <div *ngIf="element.status === 'ceased' || element.notRegistered">
                        {{ 'common.words.dashes' | translate }}
                      </div>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="creditLicenceFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="valid">
                          <small>{{ 'suppliers.fields.supplierDocuments.valid' | translate }}</small>
                        </mat-option>
                        <mat-option value="notValid">
                          <small>{{ 'suppliers.fields.supplierDocuments.notValid' | translate }}</small>
                        </mat-option>
                        <mat-option value="exemption">
                          <small>{{ 'suppliers.fields.supplierDocuments.exemption' | translate }}</small>
                        </mat-option>
                        <mat-option value="expired">
                          <small>{{ 'suppliers.fields.supplierDocuments.expired' | translate }}</small>
                        </mat-option>
                        <mat-option value="waiting">
                          <small>{{ 'suppliers.fields.supplierDocuments.waiting' | translate }}</small>
                        </mat-option>
                        <mat-option value="soa">
                          <small>{{ 'suppliers.fields.supplierDocuments.soa' | translate }}</small>
                        </mat-option>
                        <mat-option value="notReceived">
                          <small>{{ 'suppliers.fields.supplierDocuments.notReceived' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(creditLicenceFilter)" class="reset-input-icon"
                        *ngIf="creditLicenceFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="credits">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-sm text-center">
                    {{ 'suppliers.fields.credits' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.credits && element.credits > 15 && !(element.creditLicence && (element.creditLicence.type === 'soa' || element.creditLicence.type === 'exemptionPac')) && !(element.creditLicence && element.creditLicence.status === 'notReceived')">
                      <span style="color: #28a745;">{{ element.credits }}</span>
                    </div>
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.credits && element.credits < 16 && !(element.creditLicence && (element.creditLicence.type === 'soa' || element.creditLicence.type === 'exemptionPac')) && !(element.creditLicence && element.creditLicence.status === 'notReceived')">
                      <span style="color: #dc3545;">{{ element.credits }}</span>
                    </div>
                    <!-- No credits are shown when the PAC is "NON PERVENUTA": the stored value is stale -->
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && element.creditLicence.status === 'notReceived'">
                      {{ 'common.words.dashes' | translate }}
                    </div>
                    <div
                      *ngIf="element.status !== 'ceased' && !element.notRegistered && element.creditLicence && (element.creditLicence.type === 'soa' || element.creditLicence.type === 'exemptionPac')">
                      {{ 'common.words.dashes' | translate }}
                    </div>
                    <div *ngIf="element.status === 'ceased' || element.notRegistered">
                      {{ 'common.words.dashes' | translate }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="creditsFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(creditsFilter)" class="reset-input-icon"
                        *ngIf="creditsFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xxs">
                    {{ 'suppliers.fields.status' | translate }}
                    <button mat-icon-button aria-label="Info" (mouseover)="onInfoStatusPopUp()">
                      <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span *ngIf="element.status === 'active' || element.notRegistered">{{ 'suppliers.status.' +
                      element.status | translate}}</span>
                    <span style="color: #dc3545;" *ngIf="element.status !== 'active' && !element.notRegistered">{{
                      'suppliers.status.' + element.status | translate}}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="statusSuppliersFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option *ngFor="let status of statusOptions" [value]="status.value">
                          <small>{{ status.label }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(statusSuppliersFilter)" class="reset-input-icon"
                        *ngIf="statusSuppliersFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="employees">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs column-center">
                    {{ 'suppliers.fields.employees' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div *ngIf="!element.employees">
                      0
                    </div>
                    <div *ngIf="element.employees">
                      {{ element.employees }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="employeesFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(employeesFilter)" class="reset-input-icon"
                        *ngIf="employeesFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="startCompanyDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs column-center">
                    {{ 'suppliers.fields.startCompanyDate' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span
                      *ngIf="element.status === 'ceased' || (!element.startCompanyDate || element.startCompanyDate === '')">{{
                      'common.words.dashes' | translate }}</span>
                    <span *ngIf="element.status !== 'ceased' && element.startCompanyDate !== ''">{{
                      element.startCompanyDate | dateFormat }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="startCompanyDateFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(startCompanyDateFilter)" class="reset-input-icon"
                        *ngIf="startCompanyDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="qualifications">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                    {{ 'suppliers.fields.qualifications' | translate }}
                    <button mat-icon-button aria-label="Info" (mouseover)="onInfoPopUp()">
                      <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.status === 'ceased' || element.notRegistered">{{ 'common.words.dashes' |
                      translate }}</div>
                    <div *ngIf="
                        element.status !== 'ceased' &&
                        !element.notRegistered &&
                        !(
                          element.qualifications.includes('A') ||
                          element.qualifications.includes('B') ||
                          element.qualifications.includes('C') ||
                          element.qualifications.includes('D') ||
                          element.qualifications.includes('E') ||
                          element.qualifications.includes('F') ||
                          element.qualifications.includes('G')
                        )
                      ">
                      {{ 'suppliers.notExpected' | translate }}
                    </div>
                    <div *ngIf="
                          element.status !== 'ceased' &&
                          !element.notRegistered &&
                          (element.qualifications.includes('A') ||
                          element.qualifications.includes('B') ||
                          element.qualifications.includes('C') ||
                          element.qualifications.includes('D') ||
                          element.qualifications.includes('E') ||
                          element.qualifications.includes('F') ||
                          element.qualifications.includes('G'))
                      ">
                      <table class="table table-bordered qualifications-table">
                        <thead>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationA' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationB' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationC' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationD' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationE' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationF' | translate }}</th>
                          <th style="font-weight: normal;">{{ 'suppliers.fields.qualificationG' | translate }}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td><mat-icon *ngIf="element.qualifications.includes('A')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('B')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('C')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('D')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('E')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('F')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                            <td><mat-icon *ngIf="element.qualifications.includes('G')" fontSet="fas"
                                fontIcon="fa-check-square" class="qualification-icon"></mat-icon></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="qualificationsFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="A">
                          <small>{{ 'suppliers.fields.qualificationA' | translate }}</small>
                        </mat-option>
                        <mat-option value="B">
                          <small>{{ 'suppliers.fields.qualificationB' | translate }}</small>
                        </mat-option>
                        <mat-option value="C">
                          <small>{{ 'suppliers.fields.qualificationC' | translate }}</small>
                        </mat-option>
                        <mat-option value="D">
                          <small>{{ 'suppliers.fields.qualificationD' | translate }}</small>
                        </mat-option>
                        <mat-option value="E">
                          <small>{{ 'suppliers.fields.qualificationE' | translate }}</small>
                        </mat-option>
                        <mat-option value="F">
                          <small>{{ 'suppliers.fields.qualificationF' | translate }}</small>
                        </mat-option>
                        <mat-option value="G">
                          <small>{{ 'suppliers.fields.qualificationG' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(qualificationsFilter)" class="reset-input-icon"
                        *ngIf="qualificationsFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="register">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.register' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.invitationAcceptanceDate">
                      {{ 'suppliersInvitation.fields.registered' | translate }}
                    </div>
                    <div *ngIf="!element.invitationAcceptanceDate && element.invitationDate">
                      {{ 'suppliersInvitation.fields.invited' | translate }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="registerFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="registered">
                          <small>{{ 'suppliersInvitation.fields.registered' | translate }}</small>
                        </mat-option>
                        <mat-option value="invited">
                          <small>{{ 'suppliersInvitation.fields.invited' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(registerFilter)" class="reset-input-icon"
                        *ngIf="registerFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="invitationDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.invitationDate' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.invitationDate | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpInvitationDate" (focus)="dpInvitationDate.open()"
                        (click)="dpInvitationDate.open()" readonly placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="invitationDateFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetSuppliersFilter(invitationDateFilter)" class="reset-input-icon"
                        *ngIf="invitationDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpInvitationDate"></mat-datepicker-toggle>
                      <mat-datepicker #dpInvitationDate></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xs column-center">
                    {{ 'common.cta.actions' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onDeleteAssociation(element)">{{ 'suppliers.list.deleteAssociation'
                        | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="suppliersDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: suppliersDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="suppliersDisplayedColumns"></tr>
              </table>
              <mat-paginator #suppliersPaginator [length]="suppliersDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- INVITATION SUPPLIERS -->
    <mat-card class="custom-card mt-4" [hidden]="hiddenCardInvitation">
      <mat-card-title>{{ 'suppliersInvitation.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="invitationCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="row mb-2">
            <div class="col-6">
            </div>
            <div class="col-6 text-right">
            </div>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div>
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportInvitation()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersInvitaion()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="spinner-container" *ngIf="invitationDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="invitationDataSource" matSort #invitationSort="matSort"
                matSortActive="companyName" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.supplier' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a class="ml-2" [routerLink]="'../../../suppliers/detailv2/' + element._id"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}" *ngIf="!masterOnlyNfcSubscription">
                      {{ element.companyName }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="invitationSupplierFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetInvitaionFilter(invitationSupplierFilter)" class="reset-input-icon"
                        *ngIf="invitationSupplierFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="vatNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.vatNumber' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.vatNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="invitationVatNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetInvitaionFilter(invitationVatNumberFilter)" class="reset-input-icon"
                        *ngIf="invitationVatNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.email' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.email }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="invitationEmailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetInvitaionFilter(invitationEmailFilter)" class="reset-input-icon"
                        *ngIf="invitationEmailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="pec">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.pec' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.pec }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="invitationPecFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetInvitaionFilter(invitationPecFilter)" class="reset-input-icon"
                        *ngIf="invitationPecFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="register">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md">
                    {{ 'suppliersInvitation.fields.register' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.invitationAcceptanceDate">
                      {{ 'suppliersInvitation.fields.registered' | translate }}
                    </div>
                    <div *ngIf="!element.invitationAcceptanceDate && element.invitationDate">
                      {{ 'suppliersInvitation.fields.invited' | translate }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>

                      <mat-select [formControl]="invitationRegisterFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="registered">
                          <small>{{ 'suppliersInvitation.fields.registered' | translate }}</small>
                        </mat-option>
                        <mat-option value="invited">
                          <small>{{ 'suppliersInvitation.fields.invited' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetInvitaionFilter(invitationRegisterFilter)" class="reset-input-icon"
                        *ngIf="invitationRegisterFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="invitationDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: invitationDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="invitationDisplayedColumns"></tr>
              </table>
              <mat-paginator #invitationPaginator [length]="invitationDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SAFETY VIDEOS FOR SUPPLIERS -->
    <mat-card class="custom-card mt-4" *ngIf="company && loggedUser">
      <mat-card-title>
        {{ 'companies.detail.safetyVideoSuppliersCard.title' | translate }}
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.safetyVideoSuppliers" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.safetyVideoSuppliersCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="safetyVideoSuppliersCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onSafetyVideoSuppliersPrintQRcode()"
              mat-flat-button matTooltip="{{ 'common.cta.printQr' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{
              'companies.detail.safetyVideoSuppliersCard.printQrcode' | translate }}
            </button>
            <button class="add-icon-button mr-2" color="accent" (click)="onVideoPopUp('SafetyVideoSuppliers')"
              mat-flat-button matTooltip="{{ 'companies.detail.safetyVideoSuppliersCard.showVideo' | translate }}"
              matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon> {{
              'companies.detail.safetyVideoSuppliersCard.showVideo' | translate }}
            </button>
            <ng-container *ngIf="safetyVideoSuppliersQrcodeData">
              <qrcode class="d-none" id="safetyVideoSuppliersQrcodeDataImage" [qrdata]="safetyVideoSuppliersQrcodeData"
                [width]="150" [errorCorrectionLevel]="'H'" [elementType]="url"></qrcode>
            </ng-container>
            <button class="add-icon-button float-right" color="accent"
              (click)="onSafetyVideoSuppliersSendQrcodeByEmail()" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoSuppliersCard.sendQrcodeByEmail' | translate }}"
              matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> {{
              'companies.detail.safetyVideoSuppliersCard.sendQrcodeByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #safetyVideoSuppliersInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInputSafetyVideoSuppliers()"
                      class="reset-input-icon" *ngIf="safetyVideoSuppliersInput.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSafetyVideoSuppliers()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersSafetyVideoSuppliers()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="is-loading" *ngIf="safetyVideoSuppliersDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="safetyVideoSuppliersDataSource" matSort #safetyVideoSuppliersSort="matSort"
                matSortActive="createdAt" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoSuppliers.firstName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersFirstNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersFirstNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersFirstNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoSuppliers.lastName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersLastNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersLastNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersLastNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.safetyVideoSuppliers.companyName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersCompanyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersCompanyNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersCompanyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.safetyVideoSuppliers.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="safetyVideoSuppliersCreatedAtFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersCreatedAtFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="safetyVideoSuppliersDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: safetyVideoSuppliersDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="safetyVideoSuppliersDisplayedColumns"></tr>
              </table>
              <mat-paginator #safetyVideoSuppliersPaginator
                [length]="safetyVideoSuppliersDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SAFETY VIDEOS FOR RESIDENTS -->
    <mat-card class="custom-card mt-4" *ngIf="company && loggedUser">
      <mat-card-title>
        {{ 'companies.detail.safetyVideoResidentsCard.title' | translate }}
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.safetyVideoResidents" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.safetyVideoResidentsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="safetyVideoResidentsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onSafetyVideoResidentsPrintQRcode()"
              mat-flat-button matTooltip="{{ 'common.cta.printQr' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{
              'companies.detail.safetyVideoResidentsCard.printQrcode' | translate }}
            </button>
            <button class="add-icon-button mr-2" color="accent" (click)="onVideoPopUp('SafetyVideoResidents')"
              mat-flat-button matTooltip="{{ 'companies.detail.safetyVideoResidentsCard.showVideo' | translate }}"
              matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon> {{
              'companies.detail.safetyVideoResidentsCard.showVideo' | translate }}
            </button>
            <ng-container *ngIf="safetyVideoResidentsQrcodeData">
              <qrcode class="d-none" id="safetyVideoResidentsQrcodeDataImage" [qrdata]="safetyVideoResidentsQrcodeData"
                [width]="150" [errorCorrectionLevel]="'H'" [elementType]="url"></qrcode>
            </ng-container>
            <button class="add-icon-button float-right" color="accent"
              (click)="onSafetyVideoResidentsSendQrcodeByEmail()" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoResidentsCard.sendQrcodeByEmail' | translate }}"
              matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> {{
              'companies.detail.safetyVideoResidentsCard.sendQrcodeByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #safetyVideoResidentsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInputSafetyVideoResidents()"
                      class="reset-input-icon" *ngIf="safetyVideoResidentsInput.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSafetyVideoResidents()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersSafetyVideoResidents()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="is-loading" *ngIf="safetyVideoResidentsDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="safetyVideoResidentsDataSource" matSort #safetyVideoResidentsSort="matSort"
                matSortActive="createdAt" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoResidents.firstName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsFirstNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsFirstNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsFirstNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoResidents.lastName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsLastNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsLastNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsLastNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.safetyVideoResidents.companyName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsCompanyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsCompanyNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsCompanyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.safetyVideoResidents.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="safetyVideoResidentsCreatedAtFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsCreatedAtFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="safetyVideoResidentsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: safetyVideoResidentsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="safetyVideoResidentsDisplayedColumns"></tr>
              </table>
              <mat-paginator #safetyVideoResidentsPaginator
                [length]="safetyVideoResidentsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- FIRE SAFETY -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>
        {{ 'companies.detail.fireSafetyDocsCard.title' | translate }}
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.fireSafety" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.fireSafetyDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="fireSafetyDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-2">
            <!-- <h6>{{ 'companies.fields.fireSafetyDefaultDocs.subtitle' | translate }}</h6> -->
          </div>
          <div class="table-wrapper">
            <div class="table-responsive">
              <table mat-table [dataSource]="fireSafetyDocsDefaultDataSource">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"> # </th>
                  <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-30">
                    {{ 'companies.fields.fireSafetyDocs.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'companies.fields.fireSafetyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-20">
                    {{ 'companies.fields.fireSafetyDocs.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{ element.createdAt | dateFormat}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onFireSafetyDocsDownload(element)">{{ 'common.cta.downloadFile' |
                        translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDefaultDocSendByEmail(element)">{{
                        'companies.detail.fireSafetyDocsCard.sendByEmail' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsViewQrcode(element)">{{
                        'companies.fields.fireSafetyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsPrintQrcode(element)">{{
                        'companies.fields.fireSafetyDocs.command.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="fireSafetyDocsefaultDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: fireSafetyDocsefaultDisplayedColumns;"></tr>
              </table>

            </div>
          </div>
          <div class="mt-4 mb-2">
            <!-- <h6>{{ 'companies.fields.fireSafetyDocs.subtitle' | translate }}</h6> -->
          </div>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onFireSafetyDocsAddDoc()" mat-flat-button
              matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'common.cta.add' | translate }}
            </button>
            <button class="navigation-button float-right" mat-flat-button color="accent"
              (click)="onFireSafetyDocsSendByEmail()">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
              {{ 'companies.detail.fireSafetyDocsCard.sendByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #fireSafetyDocsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="fireSafetyDocsResetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onFireSafetyDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onFireSafetyDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="fireSafetyDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="fireSafetyDocsDataSource" matSort #fireSafetyDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'companies.fields.fireSafetyDocs.checkbox' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- [checked]="subSubDocItem.value.checked" -->
                    <mat-checkbox (change)="onFireSafetyDocSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>

                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.fireSafetyDocs.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="fireSafetyDocsNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onFireSafetyDocsResetFilter(fireSafetyDocsNameFilter)" class="reset-input-icon ml-n3"
                        *ngIf="fireSafetyDocsNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.fireSafetyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="fireSafetyDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onFireSafetyDocsResetFilter(fireSafetyDocsDescriptionFilter)" class="reset-input-icon"
                        *ngIf="fireSafetyDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.fireSafetyDocs.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="fireSafetyDocsCreatedAtFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onFireSafetyDocsResetFilter(fireSafetyDocsCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="fireSafetyDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onFireSafetyDocsEdit(element)">{{
                        'companies.fields.fireSafetyDocs.command.modify' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsDelete(element._id)">{{
                        'companies.fields.fireSafetyDocs.command.delete' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsDownload(element)">{{ 'common.cta.downloadFile' |
                        translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsViewQrcode(element)">{{
                        'companies.fields.fireSafetyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsPrintQrcode(element)">{{
                        'companies.fields.fireSafetyDocs.command.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="fireSafetyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: fireSafetyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="fireSafetyDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #fireSafetyDocsPaginator [length]="fireSafetyDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- NOTA INFORMATIVA (independent additional service, not tied to Privacy / Privacy SAG) -->
    <mat-card class="custom-card mt-4" [hidden]="!informativeNoteActive">
      <mat-card-title>
        {{ 'companies.detail.privacyDocsCard.titleInformativeNote' | translate }}
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.informativeNote" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.privacyDocsCard.informativeNote.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4 clearfix">
            <div class="float-right">
              <button class="navigation-button mr-2" mat-flat-button color="primary" *ngIf="informativeNoteActive"
                [disabled]="informativeNoteDocIsLoading" (click)="onInformativeNoteSendByEmail()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.informativeNote.sendByEmailTooltip' | translate }}">
                <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.informativeNote.sendByEmail' | translate }}
              </button>
              <button class="navigation-button" mat-flat-button color="primary" *ngIf="informativeNoteActive"
                [disabled]="informativeNoteDocIsLoading" (click)="onInformativeNoteDownload()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.informativeNote.generateTooltip' | translate }}">
                <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.informativeNote.generate' | translate }}
              </button>
            </div>
          </div>
          <div class="table-wrapper">
            <div class="spinner-container" *ngIf="informativeNoteDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="informativeNoteDocsDataSource" matSort #informativeNoteDocsSort="matSort"
                matSortActive="type" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.detail.privacyDocsCard.informativeNote.docType' | translate }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="informativeNoteDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #informativeNoteDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyDocsAccess(element)">{{
                        'companies.fields.privacyDocs.command.access' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewQrcode(element)">{{
                        'companies.fields.privacyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewLink(element)">{{
                        'companies.fields.privacyDocs.command.viewLink' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="privacyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
              </table>
              <mat-paginator #informativeNoteDocsPaginator [length]="informativeNoteDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- PRIVACY -->
    <mat-card class="custom-card mt-4" [hidden]="hiddenCardPrivacy">
      <mat-card-title>
        <span *ngIf="privacySagActive">{{ 'companies.detail.privacyDocsCard.titleSag' | translate }}</span>
        <span *ngIf="!privacySagActive">{{ 'companies.detail.privacyDocsCard.title' | translate }}</span>
        <mat-icon *ngIf="loggedUserAdminOrOperator && activeServices.privacy" fontSet="fas" fontIcon="fa-check-square"
          class="service-active-icon" matTooltip="{{ 'companies.detail.serviceActive' | translate }}"></mat-icon>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.privacyDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="privacyDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4 clearfix" [hidden]="!(privacySagActive || suppliers)">
            <div class="float-right">
              <button class="navigation-button" mat-flat-button color="accent" *ngIf="suppliers"
                [disabled]="privacyDocsSendPecDisabled" (click)="onPrivacyDocsSendPec()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.sendPecTooltip' | translate }}">
                <mat-icon fontSet="fal" fontIcon="fa-paper-plane"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.sendPec' | translate }}
              </button>
              <button class="navigation-button mr-2" mat-flat-button color="accent" (click)="onPrivacyDocsGenerate()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.generateTooltip' | translate }}" *ngIf="loggedUserAdminOrOperator && privacySagActive">
                <mat-icon fontSet="fal" fontIcon="fa-file-alt"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.generate' | translate }}
              </button>
            </div>
          </div>
          <div class="table-wrapper" [hidden]="!(privacySagActive || suppliers || informativeNoteActive)">
            <div class="spinner-container" *ngIf="privacyDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="privacyDocsDataSource" matSort #privacyDocsSort="matSort"
                matSortActive="type" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.detail.privacyDocsCard.type.' + element.type | translate }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="privacyDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #privacyDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyDocsAccess(element)">{{
                        'companies.fields.privacyDocs.command.access' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewQrcode(element)">{{
                        'companies.fields.privacyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewLink(element)">{{
                        'companies.fields.privacyDocs.command.viewLink' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="privacyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
              </table>
              <mat-paginator #privacyDocsPaginator [length]="privacyDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->

          <!-- PRIVACY DELLO STUDIO -->
          <div [hidden]="!privacySagActive && !privacyActive">
          <hr class="my-4">
          <h5>{{ 'companies.detail.privacyDocsCard.studioSection.title' | translate }}</h5>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onPrivacyStudioDocsAddDoc()" mat-flat-button
              matTooltip="{{ 'companies.detail.privacyDocsCard.studioSection.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.add' | translate }}
            </button>
            <button class="navigation-button float-right mr-2" mat-flat-button color="accent"
              *ngIf="privacySagActive || suppliers" (click)="onPrivacyStudioDocsSendByEmail()">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.sendByEmail' | translate }}
            </button>
            <button class="navigation-button float-right" mat-flat-button color="primary" *ngIf="privacySagActive"
              (click)="onOpenStudioPrivacyTemplatesDialog()"
              matTooltip="{{ 'companies.detail.privacyDocsCard.studioSection.downloadTemplatesTooltip' | translate }}">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.downloadTemplates' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6"></div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onPrivacyStudioDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onPrivacyStudioDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="privacyStudioDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="privacyStudioDocsDataSource" matSort #privacyStudioDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-10">
                    {{ 'companies.fields.privacyStudioDocs.checkbox' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="onPrivacyStudioDocSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyStudioDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.fields.privacyStudioDocs.types.' + element.type | translate }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="privacyStudioDocsTypeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsTypeFilter)" class="reset-input-icon ml-n3"
                        *ngIf="privacyStudioDocsTypeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyStudioDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="privacyStudioDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsDescriptionFilter)" class="reset-input-icon"
                        *ngIf="privacyStudioDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyStudioDocs.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpPrivacyStudioDocs" (focus)="dpPrivacyStudioDocs.open()"
                        (click)="dpPrivacyStudioDocs.open()" readonly placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="privacyStudioDocsCreatedAtFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="privacyStudioDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpPrivacyStudioDocs"></mat-datepicker-toggle>
                      <mat-datepicker #dpPrivacyStudioDocs></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="privacyStudioDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #privacyStudioDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyStudioDocsEdit(element)">{{
                        'companies.fields.privacyStudioDocs.command.modify' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsDelete(element._id)">{{
                        'companies.fields.privacyStudioDocs.command.delete' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsDownload(element)">{{ 'common.cta.downloadFile' |
                        translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsViewQrcode(element)">{{
                        'companies.fields.privacyStudioDocs.command.viewQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="privacyStudioDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyStudioDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="privacyStudioDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #privacyStudioDocsPaginator [length]="privacyStudioDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
          </div> <!-- /PRIVACY DELLO STUDIO -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- STUDY ARCHIVE -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'companies.detail.genericDocsDocsCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.genericDocsDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="genericDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onGenericDocsAddDoc()" mat-flat-button
              matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'common.cta.add' | translate }}
            </button>
            <button class="navigation-button float-right" mat-flat-button color="accent"
              (click)="onGenericDocsSendByEmail()">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
              {{ 'companies.detail.genericDocsDocsCard.sendByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #genericDocsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="genericDocsResetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onGenericDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onGenericDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="genericDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="genericDocsDataSource" matSort #genericDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'genericDocs.fields.checkbox' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- [checked]="subSubDocItem.value.checked" -->
                    <mat-checkbox (change)="onGenericDocSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>

                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'genericDocs.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="genericDocsNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onGenericDocsResetFilter(genericDocsNameFilter)" class="reset-input-icon ml-n3"
                        *ngIf="genericDocsNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'genericDocs.fields.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="genericDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onGenericDocsResetFilter(genericDocsDescriptionFilter)" class="reset-input-icon"
                        *ngIf="genericDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'genericDocs.fields.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="genericDocsCreatedAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onGenericDocsResetFilter(genericDocsCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="genericDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onGenericDocsEdit(element)">{{ 'genericDocs.list.modify' |
                        translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsDelete(element._id)">{{ 'genericDocs.list.delete' |
                        translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsDownload(element)">{{ 'common.cta.downloadFile' |
                        translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsViewQrcode(element)">{{ 'genericDocs.list.qrcode' |
                        translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsPrintQrcode(element)">{{
                        'genericDocs.list.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="genericDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: genericDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="genericDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #genericDocsPaginator [length]="genericDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- PHONEBOOK CARD -->
    <mat-card class="custom-card mt-4"
      *ngIf="company && loggedUser && loggedUserPermissions.includes('canReadPhonebookList')">
      <mat-card-title>{{ 'companies.detail.phonebookTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="phonebookCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <button mat-raised-button color="primary" (click)="onAddPhonebookContact()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canReadPhonebookList')"
            matTooltip="{{ 'companies.detail.phonebookTab.add.tooltip' | translate }}">
            <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>
          <div class="alert alert-warning my-3" role="alert"
            *ngIf="!company.phonebook || company.phonebook.length === 0 && (phonebookDataSource.totalCount$ | async) === 0">
            {{ 'common.words.display_no_data' | translate }}
          </div>
          <div class="is-loading" *ngIf="phonebookDataSource.loading$ | async">
            <mat-spinner diameter="50"></mat-spinner>
          </div>

          <div class="table-responsive" [ngClass]="{'d-none': ((phonebookDataSource.totalCount$ | async) === 0)}">
            <table mat-table [dataSource]="phonebookDataSource" matSort #phonebookSort="matSort"
              matSortActive="firstName" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0 w-100">
              <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ i + 1 }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                  {{ 'companies.fields.phonebook.firstName' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.firstName }} </td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                  {{ 'companies.fields.phonebook.lastName' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.lastName }} </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'companies.fields.phonebook.email' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.email }} </td>
              </ng-container>
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'common.words.createdAt' | translate }}
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.createdAt | dateTimeFormat }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.cta.actions' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <button (click)="onOpenPhonebookContact(element)" mat-icon-button color="primary"
                    matTooltip="{{ 'companies.detail.phonebookTab.openTooltip' | translate }}">
                    <mat-icon fontSet="fas" fontIcon="fa-external-link"></mat-icon>
                  </button>
                  <button (click)="onAddCommunication(element)" mat-icon-button color="primary"
                    matTooltip="{{ 'companies.detail.phonebookTab.newMessageTooltip' | translate }}">
                    <mat-icon fontSet="fas" fontIcon="fa-envelope"></mat-icon>
                  </button>
                  <button (click)="onRemovePhonebookContact(element)" mat-icon-button color="warn"
                    matTooltip="{{ 'companies.detail.phonebookTab.removeTooltip' | translate }}">
                    <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="phonebookDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: phonebookDisplayedColumns;"></tr>
            </table>
            <mat-paginator #phonebookPaginator [length]="phonebookDataSource.totalCount$ | async" [pageSize]="10"
              [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
          </div> <!-- /.table-responsive -->

        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- ACCESS LIST -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'accessLogs.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="accessListCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportAccessList()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportAccessLogs')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersAccessList()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="accessListDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="accessListDataSource" matSort #accessListSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.user' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }} {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="userFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(userFilter)" class="reset-input-icon"
                        *ngIf="userFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.email' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.email }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="emailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(emailFilter)" class="reset-input-icon"
                        *ngIf="emailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.company' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName ? element.companyName : '---' }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="companyFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(companyFilter)" class="reset-input-icon"
                        *ngIf="companyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'accessLogs.fields.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.type.toUpperCase() }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="typeAccessFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(typeAccessFilter)" class="reset-input-icon"
                        *ngIf="typeAccessFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.role' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'admin'"
                        color="primary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'master'"
                        color="primary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'operator'"
                        color="accent" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'collaborator'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'temporary'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'shared'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'external'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="!element.chosenRole || (element.chosenRole && !element.chosenRole.roleType)"
                        color="secondary" selected class="mat-chip-sm">
                        no role
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="roleFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option *ngFor="let role of filterRoleTypes" [value]="role.value">
                          {{ role.label }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(roleFilter)" class="reset-input-icon"
                        *ngIf="roleFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.ipAddress' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ipAddress }} <span *ngIf="element.ipAddress === '::1'">({{ 'common.words.you' | translate
                      }})</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="ipAddressFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(ipAddressFilter)" class="reset-input-icon"
                        *ngIf="ipAddressFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtAccessFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterAccessList(createdAtAccessFilter)" class="reset-input-icon"
                        *ngIf="createdAtAccessFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsAccessList"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsAccessList; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumnsAccessList"></tr>
              </table>
              <mat-paginator #accessListPaginator [length]="accessListDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- NOTES -->
    <div *ngIf="!loggedUserMaster" class=" mt-4">
      <app-platform-note-card [companyId]="companyId"
        (eventDeactivate)="OnPlatformNoteDeactivate($event)"></app-platform-note-card>
    </div>

    <!-- HISTORICAL NOTES -->
    <div *ngIf="!loggedUserMaster" class=" mt-4">
      <app-platform-note-card [companyId]="companyId" [historical]=true [reload]="historicalReload"
        #historicalNotes></app-platform-note-card>
    </div>

    <!-- DELETE CARD -->
    <mat-card *ngIf="companyData && loggedUser && loggedUserPermissions.includes('canDeleteCompanies')"
      class="custom-card mt-4">
      <mat-card-title *ngIf="companyData && companyData.active">
        {{ 'companies.detail.deleteTab.title' | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="companyData && !companyData.active">
        {{ 'companies.detail.deleteTab.reactivate' | translate }}
      </mat-card-title>
      <!-- <mat-card-subtitle>{{ 'common.words.deleteTabSubtitle' | translate }}</mat-card-subtitle> -->
      <mat-card-content>
        <app-card-spinner [visible]="deleteCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <ng-container *ngIf="companyData && companyData.active">
            <ng-container
              *ngIf="companyData && (!companyData.subProperties || (companyData.subProperties && !companyData.subProperties.length))">
              <p>{{ 'common.words.deleteTabWarning' | translate }}</p>
            </ng-container>
            <ng-container *ngIf="companyData && companyData.subProperties && companyData.subProperties.length">
              <div class="alert alert-warning">
                <p><strong>{{ 'common.words.warning' | translate }}!</strong></p>
                <p>{{ 'companies.detail.deleteTab.cannotDeleteWarning' | translate }}</p>
              </div>
            </ng-container>
            <mat-spinner-button (btnClick)="onDelete()" [options]="deleteBtnOptions"></mat-spinner-button>
          </ng-container>
          <ng-container *ngIf="companyData && !companyData.active">
            <mat-spinner-button (btnClick)="onReactivate()" [options]="reactivateBtnOptions">
            </mat-spinner-button>
          </ng-container>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->
